import script from "./audio-toggle-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./audio-toggle-button.vue?vue&type=script&setup=true&lang=ts"

import "./audio-toggle-button.vue?vue&type=style&index=0&id=a2b936ee&lang=scss"

const __exports__ = script;

export default __exports__